// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"bcaf1e64","703":"61472410","787":"f3536c8f"}[chunkId] + ".chunk.js";
};